import styled from 'styled-components/macro';

export const Wrapper = styled.div.attrs({ className: 'expandable-wrapper' })<{
  ms: number;
}>`
  transition: height ease-in-out;
  transition-duration: ${(props) => `${props.ms}ms`};
  height: auto;
`;
